import '../../monitoring/filters/applied_filter_view.js.coffee';# Added by Script 
Namespace 'Surveys.Views.Filters'

class Surveys.Views.Filters.AppliedSurveyView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST['backbone/templates/surveys/filters/applied_survey']
  name: 'survey'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery

  getAppliedValues: ->
    @searchQuery.get('topics')

  getSurveyName: ->
    _.first(_.pluck(@getAppliedValues(), 'name'))
